import { AccountCircle, AutoAwesome, Shield, Settings, DataThresholding } from "@mui/icons-material";
import { Box, Tab, Tabs, alpha, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotebookIcon from "@/fragments/NotebookIcon";

const SECTIONS = [
  { icon: <AccountCircle />, label: "Display", path: "/account" },

  { icon: <DataThresholding />, label: "Audience", path: "/data" },
  {
    icon: (
      <Box sx={{ display: "flex", alignItems: "center", p: 0.5 }}>
        <NotebookIcon />
      </Box>
    ),
    label: "Songs",
    path: "/songs",
  }, // TODO: add songs
  { icon: <AutoAwesome />, label: "Moderate", path: "/moderation" },
  { icon: <Settings />, label: "Admin", path: "/admin" },
];

export default function ArtistAccountTabs() {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up("lg"));

  const [tab, setTab] = useState(0);
  const navigate = useNavigate();

  const handleTabChange = (e, newValue) => {
    navigate(SECTIONS[newValue].path);
  };

  useEffect(() => {
    const tab = SECTIONS.findIndex((s) => s.path === window.location.pathname);
    setTab(tab);
  }, [window.location.pathname]);

  return (
    <Tabs
      value={tab}
      onChange={handleTabChange}
      orientation={desktop ? "vertical" : "horizontal"}
      variant="fullWidth"
      aria-label="Account sections"
      slotProps={{
        indicator: {
          sx: { top: 0, left: 0 },
        },
      }}
      sx={{
        position: "fixed",
        ...(desktop
          ? {
              left: 20,
              top: 80,
              maxHeight: "calc(100vh - 96px)",
              overflowY: "auto",
              width: 180,
            }
          : { bottom: 0, left: 0, right: 0 }),
        zIndex: 1000,
        bgcolor: alpha(theme.palette.background.paper, 0.95),
        pb: 2,
        "& .MuiTab-root": {
          minWidth: 70,
          minHeight: 70,
          justifyContent: desktop ? "flex-start" : "center",
          gap: 1,
        },
      }}
    >
      {SECTIONS.map(({ icon, label }) => (
        <Tab
          key={label}
          icon={icon}
          label={label}
          iconPosition={desktop ? "start" : "top"}
          id={`tab-${label}`}
          aria-controls={`panel-${label}`}
        />
      ))}
    </Tabs>
  );
}
